import { EnvContribution, getLegacyBindingContext } from "@visactor/vrender-core";

import { bindTTCanvasModules } from "../canvas/contributions/tt/modules";

import { bindTTWindowContribution } from "../window/contributions/tt-contribution";

import { loadMathPicker } from "../picker/math-module";

import { TTEnvContribution } from "./contributions/tt-contribution";

export function bindTTEnv(container) {
    var _a, _b;
    (null === (_b = (_a = container).isBound) || void 0 === _b ? void 0 : _b.call(_a, TTEnvContribution)) || (container.bind(TTEnvContribution).toSelf().inSingletonScope(), 
    container.bind(EnvContribution).toService(TTEnvContribution));
}

export function loadTTEnv(container = getLegacyBindingContext(), loadPicker = !0) {
    loadTTEnv.__loaded || (loadTTEnv.__loaded = !0, bindTTEnv(container), bindTTCanvasModules(container), 
    bindTTWindowContribution(container), loadPicker && loadMathPicker(container));
}

loadTTEnv.__loaded = !1;

export function initTTEnv() {
    loadTTEnv();
}
//# sourceMappingURL=tt.js.map